<section class="irembo-pagination-wrapper">
  <div
    *ngIf="!isSlice"
    class="irembo-pagination d-flex align-items-center {{
      minimalPagination
        ? 'irembogov-minimal-pagination border-0 shadow-none'
        : ''
    }}">
    <ngb-pagination
      [collectionSize]="collectionSize"
      [(page)]="page"
      (pageChange)="pageChange($event)"
      [maxSize]="maxSize"
      [size]="paginationDisplaySize"
      [rotate]="false"
      [pageSize]="pagination.pageSize"
      class="d-flex justify-content-end"
      aria-label="Custom pagination">
      <ng-container *ngIf="!minimalPagination">
        <ng-template ngbPaginationPrevious>
          <span class="d-flex align-items-center">
            <i aria-hidden="true" class="fas fa-chevron-left me-3"></i>
            <span *ngIf="showDirectionText">{{ 'Previous' | translate }}</span>
          </span>
        </ng-template>
        <ng-template ngbPaginationNext>
          <span class="d-flex align-items-center">
            <span *ngIf="showDirectionText">{{ 'Next' | translate }}</span>
            <i aria-hidden="true" class="fas fa-chevron-right ms-3"></i>
          </span>
        </ng-template>
        <ng-template ngbPaginationNumber let-p>{{
          getPageSymbol(p)
        }}</ng-template>
      </ng-container>

      <ng-container *ngIf="minimalPagination">
        <ng-template ngbPaginationPrevious>
          <button class="btn btn-sm p-1">
            <i aria-hidden="true" class="fas fa-chevron-left"></i>
          </button>
        </ng-template>
        <ng-template ngbPaginationNext>
          <button class="btn btn-sm p-1">
            <i aria-hidden="true" class="fas fa-chevron-right"></i>
          </button>
        </ng-template>
        <ng-template ngbPaginationPages let-page>
          <div class="small d-flex flex-nowrap px-2">
            <span class="col-form-label text-nowrap px-2">
              {{ 'Page' | translate }} {{ page }} of {{ getTotalPages() }}</span
            >
          </div>
        </ng-template>
      </ng-container>
    </ngb-pagination>
  </div>

  <div
    *ngIf="isSlice"
    class="irembo-pagination d-flex align-items-center {{
      minimalPagination
        ? 'irembogov-minimal-pagination border-0 shadow-none'
        : ''
    }}">
    <ul
      class="pagination mb-0 d-flex justify-content-end"
      [ngClass]="
        paginationDisplaySize ? 'pagination-' + paginationDisplaySize : ''
      ">
      <li class="page-item" [class.disabled]="page <= 1">
        <a
          class="page-link"
          (click)="previousSlicePage()"
          style="cursor: pointer">
          <span class="d-flex align-items-center">
            <i
              aria-hidden="true"
              class="fas fa-chevron-left"
              [class.me-3]="showDirectionText"></i>
            <span *ngIf="showDirectionText">{{ 'Previous' | translate }}</span>
          </span>
        </a>
      </li>

      <li
        class="page-item disabled d-flex align-items-center px-3"
        *ngIf="minimalPagination">
        <span class="small">{{ 'Page' | translate }} {{ page }}</span>
      </li>

      <li class="page-item" [class.disabled]="isLastPage">
        <a class="page-link" (click)="nextSlicePage()" style="cursor: pointer">
          <span class="d-flex align-items-center">
            <span *ngIf="showDirectionText">{{ 'Next' | translate }}</span>
            <i
              aria-hidden="true"
              class="fas fa-chevron-right"
              [class.ms-3]="showDirectionText"></i>
          </span>
        </a>
      </li>
    </ul>
  </div>

  <div class="dropdown-wrapper" *ngIf="showDropdown">
    <div ngbDropdown class="d-inline-block">
      <button type="button" class="btn" id="dropdownBasic1" ngbDropdownToggle>
        {{ pagination.pageSize }} {{ 'per page' | translate }}
      </button>
      <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
        <button
          *ngFor="let pageSize of pageSizes"
          ngbDropdownItem
          (click)="pageSizeChange(pageSize)">
          {{ pageSize }}
        </button>
      </div>
    </div>
  </div>
</section>
